exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-head[data-v-102055ce]{position:sticky;top:143px;z-index:990;background-color:#fff}[data-v-102055ce]:deep(.multiselect__input)::-moz-placeholder{color:#dcdcdc}[data-v-102055ce]:deep(.multiselect__input):-ms-input-placeholder{color:#dcdcdc}[data-v-102055ce]:deep(.multiselect__input)::placeholder{color:#dcdcdc}", ""]);

// exports
